export * from "./Sample2Settings";
